/**
 * Array filter function that sorts the given array by the first level title
 */
function sortUnitsByTitle(a,b) {
   let orderA = 4
   let orderB = 4
   let titleA = a.firstLevelTitle || ''
   let titleB = b.firstLevelTitle || ''
   if (titleA.match(/core/i)) {
      orderA = 1
   } else if (titleA.match(/major/i)) {
      orderA = 2
   } else if (titleA.match(/spine/i)) {
      orderA = 3
   }

   if (titleB.match(/core/i)) {
      orderB = 1
   } else if (titleB.match(/major/i)) {
      orderB = 2
   } else if (titleB.match(/spine/i)) {
      orderB = 3
   }

   return orderA - orderB
}

module.exports = sortUnitsByTitle
